import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft, HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';

export const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const items = t('faq.items', { returnObjects: true }) || [];
  const categories = t('faq.categories', { returnObjects: true }) || {};

  const filtered = activeCategory === 'all' ? items : items.filter(item => item.cat === activeCategory);

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }} data-testid="faq-page">
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#2563eb', textDecoration: 'none', fontWeight: 600, marginBottom: '1.5rem' }}>
        <ArrowLeft size={18} /> {t('common.back')}
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem' }}>
        <HelpCircle size={28} style={{ color: '#2563eb' }} />
        <h1 style={{ fontSize: '1.75rem', fontWeight: 800, margin: 0 }}>{t('faq.title')}</h1>
      </div>

      {/* Category Filter */}
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
        <button
          onClick={() => setActiveCategory('all')}
          data-testid="faq-filter-all"
          style={{
            padding: '0.4rem 1rem', borderRadius: '20px', border: 'none', cursor: 'pointer',
            background: activeCategory === 'all' ? '#2563eb' : '#f1f5f9',
            color: activeCategory === 'all' ? '#fff' : '#64748b', fontWeight: 600, fontSize: '0.85rem'
          }}
        >
          All
        </button>
        {Object.entries(categories).map(([key, label]) => (
          <button
            key={key}
            onClick={() => setActiveCategory(key)}
            data-testid={`faq-filter-${key}`}
            style={{
              padding: '0.4rem 1rem', borderRadius: '20px', border: 'none', cursor: 'pointer',
              background: activeCategory === key ? '#2563eb' : '#f1f5f9',
              color: activeCategory === key ? '#fff' : '#64748b', fontWeight: 600, fontSize: '0.85rem'
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* FAQ Items */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {Array.isArray(filtered) && filtered.map((item, i) => {
          const globalIndex = items.indexOf(item);
          const isOpen = openIndex === globalIndex;
          return (
            <div
              key={globalIndex}
              data-testid={`faq-item-${globalIndex}`}
              style={{
                background: '#fff', borderRadius: '12px', border: `1px solid ${isOpen ? '#bfdbfe' : '#e2e8f0'}`,
                overflow: 'hidden', transition: 'border-color 0.2s'
              }}
            >
              <button
                onClick={() => setOpenIndex(isOpen ? null : globalIndex)}
                style={{
                  width: '100%', padding: '1rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left'
                }}
              >
                <span style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.95rem' }}>{item.q}</span>
                {isOpen ? <ChevronUp size={18} style={{ color: '#2563eb', flexShrink: 0 }} /> : <ChevronDown size={18} style={{ color: '#94a3b8', flexShrink: 0 }} />}
              </button>
              {isOpen && (
                <div style={{ padding: '0 1.25rem 1rem', color: '#475569', lineHeight: 1.7, fontSize: '0.9rem' }}>
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
